/**
 * Asset Cache Configuration Module
 * Centralized exports for all configuration-related functionality
 */

// ============================================================================
// TYPE DEFINITIONS
// ============================================================================

export * from "./types";

// ============================================================================
// CONFIGURATION INTERFACES AND FUNCTIONS
// ============================================================================

export * from "./config";

// ============================================================================
// DEFAULT CONFIGURATIONS AND PRESETS
// ============================================================================

export * from "./defaults";

// ============================================================================
// CONSTANTS AND MAPPINGS
// ============================================================================

export * from "./constants";

// ============================================================================
// EXPLICIT TYPE EXPORTS (for better IDE support)
// ============================================================================

export type {
  AssetCacheConfig,
  // Core types
  AssetType,

  // Cache operation types
  CacheOptions,
  CacheEntry,
  CacheResult,
  AssetMetadata,
  CacheManifest,

  // Service worker types
  ServiceWorkerMessageType,

  // Asset loader configuration
  AssetLoaderConfig,
} from "./types";

// ============================================================================
// UTILITY FUNCTIONS
// ============================================================================

export { mergeAssetCacheConfig, validateAssetCacheConfig } from "./config";

export { getDefaultAssetCacheConfig } from "./defaults";
